import { atom } from 'jotai';

export const bannerTextAtom = atom<string | null>(null);
